import script from "./AllPartnersPageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AllPartnersPageCard.vue?vue&type=script&setup=true&lang=js"

import "./AllPartnersPageCard.vue?vue&type=style&index=0&id=43cac4f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43cac4f7"]])

export default __exports__